var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterOne2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5376 0.810059H9.46064C9.0358 0.810059 8.69141 1.15445 8.69141 1.57929V4.65621C8.69141 5.08105 9.0358 5.42544 9.46064 5.42544H12.5376C12.9624 5.42544 13.3068 5.08105 13.3068 4.65621V1.57929C13.3068 1.15445 12.9624 0.810059 12.5376 0.810059Z",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38522 13.8872H3.30829C2.88346 13.8872 2.53906 14.2316 2.53906 14.6564V17.7334C2.53906 18.1582 2.88346 18.5026 3.30829 18.5026H6.38522C6.81005 18.5026 7.15445 18.1582 7.15445 17.7334V14.6564C7.15445 14.2316 6.81005 13.8872 6.38522 13.8872Z",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6919 13.8872H15.6149C15.1901 13.8872 14.8457 14.2316 14.8457 14.6564V17.7334C14.8457 18.1582 15.1901 18.5026 15.6149 18.5026H18.6919C19.1167 18.5026 19.4611 18.1582 19.4611 17.7334V14.6564C19.4611 14.2316 19.1167 13.8872 18.6919 13.8872Z",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.42529V9.27145",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1543 9.27148V13.8869",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8457 13.8869V9.27148",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.27148H21",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterOne2);
export default __webpack_public_path__ + "static/media/footer-one-2.29c2376ca81b053239883ddd6ffae05a.svg";
export { ForwardRef as ReactComponent };